import { AdminUsersPage } from './admin-users';
import { DevBreadcrumbsComponentModule } from '../../components/dev-breadcrumbs/dev-breadcrumbs.module';
import { FlxCommonsModule } from "@questrade/flx-commons";
import { IonicPageModule } from 'ionic-angular';
import { NgModule } from '@angular/core';

@NgModule({
    declarations: [
        AdminUsersPage,
    ],
    imports: [
        DevBreadcrumbsComponentModule,
        FlxCommonsModule,
        IonicPageModule.forChild(AdminUsersPage),
    ],
    exports: [
        AdminUsersPage
    ]
})
export class AdminUsersPageModule { }



// WEBPACK FOOTER //
// ./src/pages/admin-users/admin-users.module.ts